import { Box, Button as MuiButton } from '@mui/material';
import React from 'react';
import {
  AutocompleteInput,
  BooleanInput,
  Filter,
  ReferenceInput,
  useListContext,
} from 'react-admin';
import { IDSearch } from '../../reusable/IDSearch';

const ClearFiltersButton: React.FC = () => {
  const { filterValues, setFilters } = useListContext();
  const hasFilters = Object.values(filterValues).some(
    (v) => v !== undefined && v !== null && v !== '',
  );
  if (!hasFilters) {
    return null;
  }
  return (
    <MuiButton
      variant="text"
      size="small"
      onClick={() => setFilters({}, {})}
      sx={{ whiteSpace: 'nowrap', alignSelf: 'center', mb: 0.5 }}
    >
      Clear Filters
    </MuiButton>
  );
};

const TaxonomyInput: React.FC<{
  source: string;
  reference: string;
  label: string;
}> = ({ source, reference, label }) => (
  <ReferenceInput
    source={source}
    reference={reference}
    alwaysOn
    perPage={100}
    sort={{ field: 'name', order: 'ASC' }}
  >
    <AutocompleteInput
      sx={{ width: '300px' }}
      optionText="name"
      label={label}
      filterToQuery={(name: string) => (name ? { name } : {})}
    />
  </ReferenceInput>
);

const FilterRow: React.FC<{
  alwaysOn?: boolean;
  children: React.ReactNode;
}> = ({ children }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-end',
      gap: 2,
    }}
  >
    {children}
  </Box>
);

export const ExerciseFilters: React.FC<Record<string, unknown>> = (props) => (
  <Filter {...props}>
    <FilterRow alwaysOn>
      <IDSearch label="Name" source="name" />
      <TaxonomyInput
        source="exerciseBaseId"
        reference="ExerciseBase"
        label="Base Movement"
      />
      <TaxonomyInput
        source="exerciseTypeId"
        reference="ExerciseType"
        label="Movement Type"
      />
      <TaxonomyInput
        source="exerciseTypeCategoryId"
        reference="ExerciseTypeCategory"
        label="MTC"
      />
      <TaxonomyInput
        source="exerciseTypeCategoryGroupId"
        reference="ExerciseTypeCategoryGroup"
        label="MTC Group"
      />
      <BooleanInput label="Archived" source="isArchived" />
      <ClearFiltersButton />
    </FilterRow>
  </Filter>
);

export const ExerciseTypeCategoryGroupFilters: React.FC<
  Record<string, unknown>
> = (props) => (
  <Filter {...props}>
    <FilterRow alwaysOn>
      <IDSearch label="Name" source="name" />
      <BooleanInput label="Archived" source="isArchived" />
      <ClearFiltersButton />
    </FilterRow>
  </Filter>
);

export const ExerciseTypeCategoryFilters: React.FC<Record<string, unknown>> = (
  props,
) => (
  <Filter {...props}>
    <FilterRow alwaysOn>
      <IDSearch label="Name" source="name" />
      <TaxonomyInput
        source="exerciseTypeCategoryGroupId"
        reference="ExerciseTypeCategoryGroup"
        label="MTC Group"
      />
      <BooleanInput label="Archived" source="isArchived" />
      <ClearFiltersButton />
    </FilterRow>
  </Filter>
);

export const ExerciseTypeFilters: React.FC<Record<string, unknown>> = (
  props,
) => (
  <Filter {...props}>
    <FilterRow alwaysOn>
      <IDSearch label="Name" source="name" />
      <TaxonomyInput
        source="exerciseTypeCategoryId"
        reference="ExerciseTypeCategory"
        label="MTC"
      />
      <TaxonomyInput
        source="exerciseTypeCategoryGroupId"
        reference="ExerciseTypeCategoryGroup"
        label="MTC Group"
      />
      <BooleanInput label="Archived" source="isArchived" />
      <ClearFiltersButton />
    </FilterRow>
  </Filter>
);

export const ExerciseBaseFilters: React.FC<Record<string, unknown>> = (
  props,
) => (
  <Filter {...props}>
    <FilterRow alwaysOn>
      <IDSearch label="Name" source="name" />
      <TaxonomyInput
        source="exerciseTypeId"
        reference="ExerciseType"
        label="Movement Type"
      />
      <TaxonomyInput
        source="exerciseTypeCategoryId"
        reference="ExerciseTypeCategory"
        label="MTC"
      />
      <TaxonomyInput
        source="exerciseTypeCategoryGroupId"
        reference="ExerciseTypeCategoryGroup"
        label="MTC Group"
      />
      <BooleanInput label="Archived" source="isArchived" />
      <ClearFiltersButton />
    </FilterRow>
  </Filter>
);

export const ParentSelectionFilter: React.FC<Record<string, unknown>> = (
  props,
) => (
  <Filter {...props}>
    <IDSearch label="Name" source="name" alwaysOn />
  </Filter>
);
